import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import AboutDetailed from './components/AboutDetailed';
import Products from './components/Products';
import Industries from './components/Industries';
import QualityAssurance from './components/QualityAssurance';
import Dealership from './components/Dealership';
import Blog from './components/Blog';
import Contact from './components/Contact';
import FAQ from './components/FAQ';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-detailed" element={<AboutDetailed />} />
        <Route path="/products" element={<Products />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/quality-assurance" element={<QualityAssurance />} />
        <Route path="/dealership" element={<Dealership />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
